import { useState, useEffect } from 'react';
import { getHasActiveOnboardingComponent, subscribeToOnboardingComponentCompletion } from '../utils/onboardingUtil';
import { shouldDisableOnboardingBeacons } from '../utils/selenium';

/**
 * Show Onboarding Beacons if:
 * - there is no other onboarding experiences active
 * - the beacons are not disabled via Selenium flag
 */
export const useShouldShowBeacon = () => {
  const [shouldShowBeacon, setShouldShowBeacon] = useState(false);
  useEffect(() => {
    if (shouldDisableOnboardingBeacons()) {
      return;
    }
    const checkOnIdle = window.requestIdleCallback || setTimeout;

    // Updates the beacon visibility based on the active onboarding component
    const updateBeaconVisibility = () => {
      const isActive = getHasActiveOnboardingComponent();
      setShouldShowBeacon(!isActive);
      return isActive; // Return status for potential use
    };

    // Stores the cleanup function for the onboarding component subscription
    let cleanupOnboardingComponentSubscription;
    // Checks if there is an active onboarding component and sets the state accordingly
    const checkActiveOnboardingComponent = () => {
      const isActive = updateBeaconVisibility();
      if (isActive) {
        cleanupOnboardingComponentSubscription = subscribeToOnboardingComponentCompletion(() => {
          updateBeaconVisibility();
        });
      }
    };

    // Wait for DOM to be loaded and JS thread to be idle
    if (document.readyState === 'complete') {
      checkOnIdle(() => {
        checkActiveOnboardingComponent();
      });
      return () => {
        var _cleanupOnboardingCom;
        (_cleanupOnboardingCom = cleanupOnboardingComponentSubscription) === null || _cleanupOnboardingCom === void 0 || _cleanupOnboardingCom();
      };
    } else {
      const handleLoad = () => {
        checkOnIdle(() => {
          checkActiveOnboardingComponent();
        });
      };
      window.addEventListener('load', handleLoad);
      return () => {
        var _cleanupOnboardingCom2;
        window.removeEventListener('load', handleLoad);
        (_cleanupOnboardingCom2 = cleanupOnboardingComponentSubscription) === null || _cleanupOnboardingCom2 === void 0 || _cleanupOnboardingCom2();
      };
    }
  }, []);
  return shouldShowBeacon;
};